import {
  AD_RENTS_ATTEMPT,
  AD_RENTS_SUCCESS,
  AD_RENTS_FAILED,
  //////////////////////////////
  AD_RENTS_MORE_ATTEMPT,
  AD_RENTS_MORE_SUCCESS,
  AD_RENTS_MORE_FAILED,
  //////////////////////////
  AD_RENTS_CHANGE_POSTSTATUS_SUCCESS,
  AD_RENTS_CHANGE_POSTSTATUS_FAILED,
  /////////////////////////////////
  AD_RENTS_REMOVE_SUCCESS,
  AD_RENTS_REMOVE_FAILED,
  ////////////////////////////////
  AD_RENTS_NEW_SUCCESS,
  AD_RENTS_NEW_FAILED,
  LOGOUT,
} from "../types/adRentsTypes";

const INITIAL_STATE = {
  loading: false,
  loaded: false,
  list: [],
  error: "",

  loadingMore: false,
  page_count: 0,
  page_size: 0,
};
function adRents(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AD_RENTS_ATTEMPT:
      return {
        ...state,
        loading: true,
      };

    case AD_RENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.data.list,
        page_size: action.data.size,
        page_count: action.data.size,
        error: "",
      };

    case AD_RENTS_FAILED:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
        adPublishList: [],
      };
    ///////////////////////////////////////
    case AD_RENTS_MORE_ATTEMPT:
      return {
        ...state,
        loadingMore: true,
      };

    case AD_RENTS_MORE_SUCCESS:
      return {
        ...state,
        loadingMore: false,
        list: state.list.concat(action.data.list),
        page_size: action.data.size,
        page_count: state.page_count + action.data.size,
      };

    case AD_RENTS_MORE_FAILED:
      return {
        ...state,
        loadingMore: false,
      };
    /////////////////////////////////////////////
    case AD_RENTS_CHANGE_POSTSTATUS_SUCCESS: {
      if (action.item.PostStatus === 2) {
        return {
          ...state,
          list: [action.item, ...state.list],
          page_count: state.page_count + 1,
        };
      } else {
        const newState = state.list.filter((item) => {
          return item.Id !== action.item.Id;
        });
        return {
          ...state,
          list: newState,
          page_count: state.page_count - 1,
        };
      }
    }

    case AD_RENTS_CHANGE_POSTSTATUS_FAILED:
      return {
        ...state,
        error: action.error,
      };
    ///////////////////////////////////////////////////
    case AD_RENTS_REMOVE_SUCCESS: {

      const newState = state.list.filter((item) => {
        return item.Id !== action.item.Id;
      });
      return {
        ...state,
        list: newState,
        page_count: state.page_count - 1,
      };

    }

    case AD_RENTS_REMOVE_FAILED:
      return {
        ...state,
        error_update: action.error,
      };
    /////////////////////////////////////////////////
    case AD_RENTS_NEW_SUCCESS: {
      return {
        ...state,
        list: [action.item, ...state.list],
        page_count: state.page_count + 1,
        error_update: "",
      };
    }

    case AD_RENTS_NEW_FAILED:
      return {
        ...state,
        error_update: action.error,
      };

    default:
      return state;
  }
}
export default adRents;
